module.exports = __webpack_public_path__ + "static/media/tas-networks.a23d3e93.png";